import React from 'react';

import { useData } from '@shared/api/hooks/useData';
import { getTransportScans } from '@shared/transport-scans/endpoints/getTransportScans';
import { Badge } from '@shared/ui/components/Badge';
import { DataTable } from '@shared/ui/components/DataTable';
import { Icon } from '@shared/ui/components/Icon';
import { Portlet } from '@shared/ui/components/Portlet';
import { Tooltip } from '@shared/ui/components/Tooltip';

import { AdminWrapper } from '@admin/layout/components/AdminWrapper';

type TransportScanData = App.Domain.Gatekeeping.Data.TransportScanData;
type TransportScanType = App.Domain.Gatekeeping.Enums.TransportScanType;

export function TransportScansList() {
  const transportScans = useData<TransportScanData>({
    key: 'transport-scans',
    get: getTransportScans,
  });

  const typeLabels: { [K in TransportScanType]: string } = {
    transport_voucher: 'Transport Voucher',
    frequent_passage_sticker: 'Frequent Passage Sticker',
    manual: 'Manual',
  };

  return (
    <AdminWrapper title="Transport Log">
      <Portlet>
        <DataTable<TransportScanData>
          data={transportScans}
          columns={[
            {
              name: 'type',
              render: (item) => (
                <Tooltip
                  content={`${typeLabels[item.type]}${item.transportVoucher?.transportRequest.gateRequest ? ' - Printed at gate' : ''}`}
                >
                  <Badge>
                    {typeLabels[item.type]}{' '}
                    {item.transportVoucher?.transportRequest.gateRequest && <Icon icon="print" className="ml-2" />}
                  </Badge>
                </Tooltip>
              ),
              filterable: {
                type: 'select',
                icon: 'tag',
                options: [
                  {
                    value: 'transport_voucher',
                    label: 'Transport Voucher',
                  },
                  {
                    value: 'frequent_passage_sticker',
                    label: 'Frequent Passage Sticker',
                  },
                  {
                    value: 'manual',
                    label: 'Manual',
                  },
                ],
              },
            },
            {
              name: 'driverName',
              filterable: { icon: 'user' },
              render: (item) => (
                <>
                  {item.driverName}
                  <p className="text-sm">{item.driverTelephone}</p>
                </>
              ),
            },
            {
              name: 'licensePlate',
              filterable: true,
            },
            {
              name: 'companyName',
              filterable: true,
            },
            {
              name: 'gateId',
              label: 'Gate',
              render: (item) => (
                <>
                  {item.gate.name}
                  {item.location && <p className="text-sm">{item.location.name}</p>}
                </>
              ),
            },
            {
              name: 'scannedAt',
              label: 'Time',
              type: 'datetime',
            },
          ]}
        />
      </Portlet>
    </AdminWrapper>
  );
}
